import React from 'react';
import MyModules from "./MyModules";
import MainModule from "./MainModule";

const Servers = () => {
    return (
        <div>
            <MyModules />
            {/*<MainModule />*/}
        </div>
    );
};

export default Servers;